import { REQUEST_ADD_SKILL_DETAILS, RECEIVE_ADD_SKILL_DETAILS, UPDATE_ADD_SKILL_DETAILS_VALUES, CLEAR_ADD_SKILL_DETAILS_VALUES} from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { getBackendUrl } from '../env';

// Action Creators
const requestAddSkillDetails = scene => ({
    type: REQUEST_ADD_SKILL_DETAILS,
    scene: scene
});

const receiveAddSkillDetails = (scene, addedSkillDetails) => ({
    type: RECEIVE_ADD_SKILL_DETAILS,
    scene: scene,
    addedSkillDetails: addedSkillDetails
});

export const updateAddSkillDetailsFormValues = values => ({
    type: UPDATE_ADD_SKILL_DETAILS_VALUES,
    values: values
});

export const clearAddSkillDetailsFormValues = () => ({
    type: CLEAR_ADD_SKILL_DETAILS_VALUES
});

export const cleanupAddSkillDetails = scene => ({
    type: REQUEST_ADD_SKILL_DETAILS,
    scene: scene,
    cleanup: true
});

// Action Logic
export const addSkillDetails = (scene, payload) => dispatch => {
    dispatch(requestAddSkillDetails(scene));

    return fetch(`${getBackendUrl()}/api/v1/data/activityScoreDetail`, {method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json'}})
        .then(getBody)
        .then(json => dispatch(receiveAddSkillDetails(scene, json)));
};

const canAddSkillDetails = (values, state) => {
    return !state.isAdding && values.dataset && !isNaN(values.dataset);
};

export const addSkillDetailsIfOK = (scene, values) => (dispatch, getState) => {
    var skillDetailsDataState = getState().ui.addSkillDetailsData;

    if (canAddSkillDetails(values, skillDetailsDataState)) {
        console.log("Adding skill details with values:", values);
        const payload = {
            activityIdentifier: values.activityIdentifier,
            datasetNumber: Number(values.dataset),
            skillId: values.skillName,
            activitySpecificData: values.activitySpecificData,
            scoringBehavior: values.scores,
        };

        return dispatch(addSkillDetails(scene, payload))
            .catch(err => {
                dispatch(cleanupAddSkillDetails);
                dispatch(displayError(err));
            }
        ); 
    }
};



// WEBPACK FOOTER //
// ./src/actions/addSkillDetails.js